// src/mobile/MobileLocation.js
import React from "react";
import { Helmet } from "react-helmet";

const MobileLocation = () => {
  // JSON-LD de LocalBusiness (ajusta datos reales)
  const localBusinessJsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Heritage Car Airport",
    "image": "https://heritagecarairport.com/images/logo.jpg",
    "@id": "https://heritagecarairport.com/",
    "url": "https://heritagecarairport.com/",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "395 Hallocks Mill Rd",
      "addressLocality": "Yorktown Heights",
      "addressRegion": "NY",
      "postalCode": "10598",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "41.2789",
      "longitude": "-73.7837"
    },
    "telephone": "+1-914-276-2961",
    "priceRange": "$$",
    "description": "Taxi Service instantly available 24/7. Safe and reliable airport transfers."
  };

  return (
    <>
      {/* SEO avanzado con React Helmet */}
      <Helmet>
        <title>Heritage Car Airport - Location & Contact</title>
        <meta
          name="description"
          content="Find our location on the map. Taxi service instantly available 24/7. Contact us by phone or email."
        />
        <meta name="robots" content="index,follow" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Heritage Car Airport - Location & 24/7 Taxi Service"
        />
        <meta
          property="og:description"
          content="View our map and contact Heritage Car Airport for safe, reliable taxi rides available 24/7."
        />
        <meta property="og:url" content="https://heritagecarairport.com/location" />
        <meta
          property="og:image"
          content="https://heritagecarairport.com/images/your-og-image.jpg"
        />

        {/* Twitter Cards */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Heritage Car Airport - 24/7 Taxi Service"
        />
        <meta
          name="twitter:description"
          content="Find our location and contact us for an instant taxi, available 24 hours a day."
        />
        <meta
          name="twitter:image"
          content="https://heritagecarairport.com/images/your-og-image.jpg"
        />

        {/* LocalBusiness JSON-LD */}
        <script type="application/ld+json">
          {JSON.stringify(localBusinessJsonLd)}
        </script>
      </Helmet>

      <div style={styles.container}>
        <div style={styles.mapContainer}>
          <iframe
            title="Heritage Car Airports Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2930.5!2d-73.7414121!3d41.4763134!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2b7b11a6cf2e5%3A0x8a9d408a32fdf9d2!2sHeritage%20Car%20Service!5e0!3m2!1sen!2sus!4v1672481726912!5m2!1sen!2sus"
            width="100%"
            height="250"
            style={{ border: 0, borderRadius: "8px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* Texto en azul marino oscuro con sombra */}
        <div style={styles.aestheticText}>
          TAXI SERVICE Instantly – Available 24/7
        </div>

        {/* Botones 3D */}
        <div style={styles.buttonsContainer}>
          <a style={styles.actionButton} href="tel:9142762961">
            Call (914) 276-2961
          </a>
          <a style={styles.actionButton} href="tel:8452258161">
            Call (845) 225-8161
          </a>
          <a
            style={styles.actionButton}
            href="mailto:heritagecarairport@gmail.com?subject=Taxi%20Inquiry"
          >
            Send Email
          </a>
        </div>
      </div>
    </>
  );
};

const styles = {
  container: {
    padding: "20px",
    textAlign: "center",
    maxWidth: "600px",
    margin: "0 auto",
  },
  mapContainer: {
    marginBottom: "15px",
  },
  aestheticText: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    marginBottom: "20px",
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: "#0d2b3e", // Azul marino oscuro
    textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "15px",
  },
  actionButton: {
    backgroundColor: "#9AA6B2",
    color: "#fff",
    textDecoration: "none",
    padding: "14px 24px",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "1rem",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    width: "80%",
    maxWidth: "300px",
    boxShadow: "0 5px 0 #000000, 0 8px 15px rgba(0,0,0,0.2)",
    display: "block",
    textAlign: "center",
  },
};

export default MobileLocation;
